import {
	EnhancedDropDownRHFWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { Box } from "@mui/material";
import { FC } from "react";

const securityQuestions = [
	{ label: "What is your Mother's birthplace?", value: "What is your Mother's birthplace?" },
	{ label: "What is the name of your first pet?", value: "What is the name of your first pet?" },
	{ label: "What is the name of your favorite teacher?", value: "What is the name of your favorite teacher?" },
	{ label: "What is the first name of your favorite uncle?", value: "What is the first name of your favorite uncle?" },
	{ label: "What is the first name of your favorite aunt?", value: "What is the first name of your favorite aunt?" },
	{ label: "What is your oldest cousin's name?", value: "What is your oldest cousin's name?" },
	{ label: "Where did you spend your honeymoon?", value: "Where did you spend your honeymoon?" },
	{ label: "What is your oldest child's nickname?", value: "What is your oldest child's nickname?" },
	{ label: "What is your youngest child's nickname?", value: "What is your youngest child's nickname?" },
];
interface ISecurityQuestionsSetupFieldsPanel { }
export const SecurityQuestionsSetupFieldsPanel: FC<
	ISecurityQuestionsSetupFieldsPanel
> = ({ }) => {
	return (
		<Box>
			<EnhancedDropDownRHFWithLabel
				label="Question 1"
				items={securityQuestions}
				testId={"question-1"}
				selectName={"questionOne"}
			/>
			<RHookFormTextFieldWithLabel
				label="Answer"
				id="answerOne"
				testId={`answer-1`}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Question 2"
				items={securityQuestions}
				testId={"question-2"}
				selectName={"questionTwo"}
			/>
			<RHookFormTextFieldWithLabel
				label="Answer"
				id="answerTwo"
				testId={`answer-2`}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Question 3"
				items={securityQuestions}
				testId={"question-3"}
				selectName={"questionThree"}
			/>
			<RHookFormTextFieldWithLabel
				label="Answer"
				id="answerThree"
				testId={`answer-3`}
			/>
		</Box>
	);
};
